import React from "react";

const IconArrowUp = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ?? "22"}
      height={props.height ?? "22"}
      viewBox="0 0 9.395 12.604"
      {...props}
    >
      <g id="Group_903" data-name="Group 903" transform="translate(1.414 1)">
        <path
          id="Path_3595"
          data-name="Path 3595"
          d="M3892.681,2038.447V2027.9"
          transform="translate(-3889.739 -2027.843)"
          fill="none"
          stroke={props.stroke ?? "#000"}
          strokeLinecap="round"
          strokeWidth={props.strokeWidth ?? "2"}
        />
        <path
          id="Path_3596"
          data-name="Path 3596"
          d="M3889.74,2031l3.035-3.157,3.532,3.532"
          transform="translate(-3889.74 -2027.843)"
          fill="none"
          stroke={props.stroke ?? "#000"}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={props.strokeWidth ?? "2"}
        />
      </g>
    </svg>
  );
};

export default IconArrowUp;
